<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-card>
        <v-card-title class="headline">{{$t('common.select-friends')}}</v-card-title>
        <v-card-text>
          <div v-if="friends && friends.length == 0">
            <span>Keine Freunde gefunden</span>
          </div>
          <v-list>
            <v-list-item-group v-model="selectedIndices" multiple>
              <template v-for="friend in friends">
                <v-list-item :key="friend.uid">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active" @click="toggle"></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        <user-widget :user="friend" :showButtons="false" />
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="cancelDialog()">
            <v-icon left>mdi-close-circle</v-icon>{{$t('common.cancel')}}
          </v-btn>
          <v-btn class="primary" text @click="accept()">
            <v-icon left>mdi-check</v-icon>{{$t('common.take-over')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ACTION_LOAD_FRIENDS } from "@/plugins/store";

export default {
  name: "FriendsSelectorDialog",
  components: {
  },
  props: {
    value: Array,
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
    acceptAction: {
      type: Function,
      required: false
    },
    users: {
      type: Array,
      required: false,
      default: null
    }
  },
  data: function() {
    return {
      dialog: false,
      firstShow: true,
      selectedIndices: [],
      selectedFriends: []
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "500";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    },
    friends: function() {
      return this.users ? this.users : this.$store.state.friends;
    }
  },
  watch: {
    visible: function(val) {
      this.dialog = val
      if (val == true) {
        this.$ga.send({
          hitType: "event",
          eventCategory: "Friends",
          eventAction: "select",
          eventLabel: "Select friends"
        });
        if (this.firstShow) {
          this.refresh()
          this.firstShow = false
        }
      }
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    },
    value: function(val) {
      // console.log("value changed to", val);
      this.selectedFriends = val;
      this.selectedIndices = this.getIndicesOfSelected(
        this.friends,
        this.selectedFriends
      );
    }
  },
  mounted() {
    this.dialog = this.visible;
    this.selectedFriends = this.value ? this.value : [];
    this.selectedIndices = this.getIndicesOfSelected(
      this.friends,
      this.selectedFriends
    );
  },
  methods: {
    getIndicesOfSelected(friends, selectedFriends) {
      let arr = [];
      selectedFriends.forEach(user => {
        if (!user) return;
        let idx = friends.findIndex(f => {
          return f.uid == user.uid;
        });
        if (idx >= 0) {
          arr.push(idx);
        }
      });
      return arr;
    },
    accept() {
      let selected = [];
      for (var idx in this.selectedIndices) {
        let selectedIndex = this.selectedIndices[idx];
        selected.push(this.friends[selectedIndex]);
      }
      if (!this.value) {
        // if v-model is not set
        this.selectedFriends = [];
        this.selectedIndices = [];
      } else {
        this.selectedFriends = selected;
      }
      this.$emit("input", selected);
      this.dialog = false;
      this.acceptAction && this.acceptAction(selected);
    },
    cancelDialog() {
      this.selectedIndices = this.getIndicesOfSelected(
        this.friends,
        this.selectedFriends
      );
      this.closeAction();
    },
    refresh() {
      this.$store.dispatch(ACTION_LOAD_FRIENDS);
    }
  }
};
</script>
<style scoped>
</style>